import keyBy from 'lodash/keyBy'
import values from 'lodash/values'

import { setIn } from '../../utils/setIn'
import { getTerminalVisitsDataset } from '../../utils/terminalPlannerUtils'

export function appReducer(state = {}, action) {
  switch (action.type) {
    case 'SET_TERMINAL_CONFIG': {
      return Object.assign({}, state, { config: action.config })
    }
    case 'SET_SELECTED_DATE_RANGE': {
      return setIn(state, ['dateRange'], action.value)
    }
    case 'SET_SELECTED_DATA_RANGE': {
      return setIn(state, ['dataRange'], action.value)
    }
    case 'SET_SELECTED_VISIT': {
      let updatedState = state

      updatedState = setIn(updatedState, ['selectedVisit'], action.selectedVisit)
      updatedState = setIn(updatedState, ['selectedOrderId'], action.selectedOrderId)

      return updatedState
    }
    case 'SET_SELECTED_MAINTENANCE': {
      return setIn(state, ['selectedMaintenance'], action.value)
    }
    case 'SET_TERMINAL_VISITS': {
      return setIn(state, ['terminalVisits'], action.value)
    }
    case 'UPDATE_TERMINAL_VISIT': {
      const filteredVisits = state.terminalVisits.filter(visit => visit._id !== action.terminalVisit._id)
      filteredVisits.push(action.terminalVisit)

      return setIn(state, ['terminalVisits'], filteredVisits)
    }

    case 'CHANGE_TERMINAL_VISITS': {
      const terminalVisitsById = keyBy(state.terminalVisits, '_id')

      action.terminalVisitChanges.forEach(change => {
        if (change.action === 'CREATE' || change.action === 'UPDATE') {
          terminalVisitsById[change.terminalVisit._id] = change.terminalVisit
        }

        if (change.action === 'DELETE') {
          delete terminalVisitsById[change.terminalVisitId]
        }
      })

      const terminalVisits = getTerminalVisitsDataset(values(terminalVisitsById), state.config)

      // Note: original order of the visits will be lost, not sure if that's a problem
      return setIn(state, ['terminalVisits'], terminalVisits)
    }

    case 'SET_ACTIVE_OVERLAYS': {
      return setIn(state, ['activeOverlays'], action.overlays)
    }
    case 'SET_CONFLICT_MODAL_DIMENSIONS': {
      return setIn(state, ['conflictModalDimensions'], action.dimensions)
    }
    case 'SET_CONFLICT_MODAL_CONFLICTS': {
      return setIn(state, ['conflictModalConflicts'], action.conflicts)
    }
    case 'RECEIVE_TERMINAL_VISITS_SUCCESS': {
      return Object.assign({}, state, { terminalVisits: action.terminalVisits })
    }
    case 'REQUEST_TERMINAL_VISITS': {
      return Object.assign({}, state, { terminalVisits: [] })
    }
    case 'RECEIVE_BERTHS_OCCUPATION_SUCCESS': {
      return Object.assign({}, state, { berthsOccupation: action.berthsOccupation })
    }
    case 'REQUEST_BERTHS_OCCUPATION': {
      return Object.assign({}, state, { berthsOccupation: null })
    }
    case 'UPDATE_TERMINAL_CONFIG': {
      return setIn(state, ['config'], action.config)
    }
    case 'REQUEST_TERMINAL_MAINTENANCE': {
      return Object.assign({}, state, { terminalMaintenance: [] })
    }
    case 'RECEIVE_TERMINAL_MAINTENANCE_SUCCESS': {
      return Object.assign({}, state, { terminalMaintenance: action.terminalMaintenance })
    }
    case 'UPDATE_TERMINAL_MAINTENANCE': {
      return setIn(state, ['terminalMaintenance'], action.terminalMaintenance)
    }
    case 'SET_TERMINAL_MAINTENANCE': {
      return setIn(state, ['terminalMaintenance'], action.value)
    }

    default:
      return state
  }
}
